import { CreateOrUpdateLicencePackageDto } from './CreateLicencePackageDto.interface';

// eslint-disable-next-line @typescript-eslint/no-type-alias
export interface LicenceDataDto extends CreateOrUpdateLicencePackageDto {
    packageId: string;
    renewalDate: Date;
    organizationId: string;
}
